package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ClassSubjectLinkResponse(
    @SerialName("class_section_id")
    val classSectionId: String? = null,
    @SerialName("subject_id")
    val subjectId: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null
)
